export const namespace = 'settings'
